import { fetchIPERC, fetchIPERCFirma } from "./http-common";
import { IBodyFirma } from "../Interfaces/IIPERC";
import { Ifilter } from "../Interfaces/filter";
import {
  IIPercPeligroDetalle,
  IIpercPeligroPost,
  IPOSTActividad,
  IRequestTableHistoricoIPERC,
} from "../Interfaces/IIpercBase";
import { IRequestFilterActividades } from "../Interfaces/IPERC/IActividad";

const urlIPERC = "Iperc";
const urlPlantillaIperc = "PlantillaIperc";
const urlActividad = "Actividad";
const urlEquipo = "Equipo";
const urlePeligro = "Peligro";

const postTablaHistorial = (
  filter: any,
  controller = new AbortController()
) => {
  return fetchIPERC.post(`${urlIPERC}/Historial`, filter, {
    signal: controller.signal,
  });
};

const listarDetalle = (query: any) => {
  return fetchIPERC.get(`${urlIPERC}/ListarValidacion`, {
    params: query,
  });
};

const listaAreas = () => {
  return fetchIPERC.get(`Area/Lista`);
};
const actualizarArea = (body: any) => {
  return fetchIPERC.put(`Area`, body);
};

const agregarArea = (body: any) => {
  return fetchIPERC.post(`Area`, body);
};

const eliminarArea = (body: any) => {
  return fetchIPERC.delete(`Area/${body.id}`);
};

const listarUbicaciones = (obj: any) => {
  return fetchIPERC.get(`Ubicacion/${obj.AreaId}`);
};

const agregarUbicaciones = (body: any) => {
  return fetchIPERC.post(`Ubicacion`, body);
};

const eliminarUbicacion = (body: any) => {
  return fetchIPERC.delete(`Ubicacion/${body.id}`);
};

const listarNivelUbicacion = (obj: any) => {
  return fetchIPERC.get(`Ubicacion/Nivel/${obj.ubicacionId}`);
};

const agregarNivel = (body: any) => {
  return fetchIPERC.post(`Ubicacion/Nivel`, body);
};

const comboActividades = (search: string) => {
  return fetchIPERC.get(`Actividad/Combo`, { params: search });
};

const comboEstados = (search: string) => {
  return fetchIPERC.get(`Estado/Combo`, { params: search });
};

const firmaIPERC = (body: IBodyFirma) => {
  return fetchIPERCFirma.post(`Exportar`, body);
};

const listaProcesos = () => {
  return fetchIPERC.get(`Proceso/Listar`);
};

const listaIpercs = (filters: Ifilter) => {
  return fetchIPERC.get(`${urlIPERC}/Lista`, { params: filters });
};

const IpercUnico = (ActividadId: string) => {
  return fetchIPERC.get(
    `${urlPlantillaIperc}/Listar?ActividadId=${ActividadId}`
  );
};

const ListaActividades = () => {
  return fetchIPERC.get(`${urlActividad}/Listar`);
};
const ListaActividadesByPersona = (request:IRequestFilterActividades) => {
  return fetchIPERC.get(`${urlActividad}/ListarByPersona`,{params:request});
};

const ListaEquipos = () => {
  return fetchIPERC.get(`${urlEquipo}/Lista`);
};

const CrearActividad = (OBJPOST: IPOSTActividad) => {
  return fetchIPERC.post(`${urlActividad}`, OBJPOST);
};

const AgregarPeligro = (OBJPOST: IIpercPeligroPost) => {
  return fetchIPERC.post(`${urlePeligro}/Crear`, OBJPOST);
};
const ActulizarPeligro = (Body: IIPercPeligroDetalle) => {
  return fetchIPERC.post(`${urlePeligro}/Actulizar`, Body);
};
const postListarTableIperc = (
  Body: IRequestTableHistoricoIPERC,
  controller = new AbortController()
) => {
  return fetchIPERC.post(`Iperc/ListarIpercPorSupervisor`, Body, {
    signal: controller.signal,
  });
};

// Listar pdfBlob en base 64
const listarAdjuntoHistoria = (body: any) => {
  return fetchIPERC.post(`${urlIPERC}/HistorialAdjunto`, body);
};
const IPERCService = {
  postTablaHistorial,
  listarDetalle,
  listaAreas,
  actualizarArea,
  agregarArea,
  eliminarArea,
  listarUbicaciones,
  agregarUbicaciones,
  eliminarUbicacion,
  listarNivelUbicacion,
  agregarNivel,
  comboActividades,
  comboEstados,
  firmaIPERC,
  listaProcesos,
  listaIpercs,
  IpercUnico,
  ListaActividades,
  ListaEquipos,
  CrearActividad,
  AgregarPeligro,
  ActulizarPeligro,
  postListarTableIperc,
  listarAdjuntoHistoria,
  ListaActividadesByPersona
};

export default IPERCService;
